import FqApi from '@/services/fq-api'
import ProtoBufApi from '@/services/protobuf-api'
import { GlAccountTypes } from '@/enums'
import ProtoBuf from 'protobufjs'

export default {
  async getEntity(id, hash) {
    const url = !hash ? `/quickinvoices/${id}` : `/quickinvoices/${id}?hash=${hash}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getEntitySummaries(filter) {
    const serialised = this.serialiseQuickInvoiceFilter(filter)
    const url = `/quickinvoices/list/${serialised}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getAssetDropdown(filter) {
    const serialised = this.serialiseQuickInvoiceAssetDropdownFilter(filter)
    const url = `/quickinvoices/assets/listcombo/${serialised}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getAssetDropdownProto(filter) {
    const serialised = this.serialiseQuickInvoiceAssetDropdownFilter(filter)
    const result = await ProtoBufApi(`/quickinvoices/protobuf/assets/listcombo/${serialised}`)
    const proto = require('../../assets/proto/quickinvoice/QuickInvoiceAssetDropdown.proto')
    const message = proto.QuickInvoiceAssetDropdown.QuickInvoiceAssetDropdownModel
    const entity = message.decode(new Uint8Array(result.data))
    return entity.assets
  },
  async getContactDropdown(assetId) {
    const url = `/quickinvoices/protobuf/contacts/listcombo/${assetId}`
    const result = await ProtoBufApi.get(url)
    const proto = require('../../assets/proto/quickinvoice/QuickInvoiceContactDropdown.proto')
    const message = await proto.QuickInvoiceContactDropdown.QuickInvoiceContactDropdownModel
    const entity = message.decode(new Uint8Array(result.data))
    return entity.contacts
  },
  async getGlAccountDropdown() {
    const result = await ProtoBufApi(`/protobuf/glaccounts/listcombo?glTypes=${GlAccountTypes.Income}`)
    const glAccountProto = require('../../assets/proto/listcombo/GlAccount.proto')
    const accountMessage = await glAccountProto.GlAccount.GlAccountListComboModel
    const entity = accountMessage.decode(new Uint8Array(result.data))
    return entity.glAccounts
  },
  async getQuickItems(filter) {
    const serialised = this.serialiseQuickItemFilter(filter)
    const url = `/quickinvoices/quickitems/${serialised}`
    const result = await FqApi.get(url)
    return result.data
  },
  serialiseQuickInvoiceFilter(filter) {
    const entityProto = require('../../assets/proto/quickinvoice/QuickInvoiceFilter.proto')
    const filterMessage = entityProto.QuickInvoiceFilter.QuickInvoiceFilterModel
    const buffer = filterMessage.encode(filter).finish()
    const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
    return b64encoded
  },
  serialiseQuickInvoiceAssetDropdownFilter(filter) {
    const entityProto = require('../../assets/proto/quickinvoice/QuickInvoiceAssetDropdownFilter.proto')
    const filterMessage = entityProto.QuickInvoiceAssetDropdownFilter.QuickInvoiceAssetDropdownFilterModel
    const buffer = filterMessage.encode(filter).finish()
    const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
    return b64encoded
  },
  serialiseQuickItemFilter(filter) {
    const entityProto = require('../../assets/proto/quickitem/QuickItemFilter.proto')
    const filterMessage = entityProto.QuickItemFilter.QuickItemFilterModel
    const buffer = filterMessage.encode(filter).finish()
    const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
    return b64encoded
  },
  putQuickInvoice(entity, deepdiff) {
    if (deepdiff) {
      entity.deepDiff = JSON.stringify(deepdiff)
    }
    return FqApi.put(`/quickinvoices/${entity.invoiceId}`, entity)
  },
  async postEntity(entity) {
    return FqApi.post('/quickinvoices', entity)
  },
  async getNewEntity() {
    const result = await FqApi.get('/quickinvoices/new')
    return result.data
  },
  async getAssetEmail(assetId, assetType) {
    const url = `/quickinvoices/getassetemail/${assetId}/${assetType}`
    const result = await FqApi.get(url)
    return result.data
  }
}
